import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchTaxDocuments } from '../actions/tax.actions';
import { useRetry } from './useRetry';

interface UseTaxDocumentProps {
    fetchTaxDocumentsWithRetry: () => Promise<void>;
    retryCount: number;
    isRetrying: boolean;
    failedToLoad: boolean;
}

export const useTaxDocuments = (): UseTaxDocumentProps => {
    const dispatch = useDispatch();
    const [failedToLoad, setFailedToLoad] = useState<boolean>(false);

    const { asyncActionWithRetry, retryCount, isRetrying } = useRetry({
        maxTimes: 0,
        retryDelay: 1000,
        onRetry: (attempt) => {
            console.log(`Retrying tax document fetch, attempt ${attempt}`);
        },
        onMaxTimesReached: () => {
            setFailedToLoad(true);
            console.log('Max retries reached for tax document fetch');
        }
    });

    const fetchTaxDocumentsWithRetry = useCallback(async (): Promise<void> => {
        try {
            await asyncActionWithRetry(async () => {
                const result = await dispatch(fetchTaxDocuments() as any);
                if (fetchTaxDocuments.rejected.match(result)) {
                    throw new Error(result.payload as string);
                }
                return result.payload;
            });
        } catch (error) {
            console.error('Failed to fetch tax documents:', error);
            throw error;
        }
    }, [dispatch, asyncActionWithRetry]);

    return {
        fetchTaxDocumentsWithRetry,
        retryCount,
        isRetrying,
        failedToLoad
    };
};
